module.exports = __webpack_public_path__ + "static/Spain-Step3-b8b23f69a8af3d559c509cff7b091325.png";